export default "__VITE_ASSET__CErcB4kl__"